import styled, { css } from 'styled-components';
import { BreakpointSizes } from 'dbi-pearl-ui-kit';

const layoutHeight = (topOffset) => (topOffset > 0 ? `calc(100vh - ${topOffset}px)` : '100vh');

const compactLayoutHeight = (topOffset) => (topOffset === 0 ? '100%' : layoutHeight(topOffset));

export default styled.div`
    display: grid;
    height: ${({ $topOffset, $compactScroll }) =>
        $compactScroll ? compactLayoutHeight($topOffset) : layoutHeight($topOffset)};
    grid-template-columns: 1fr;
    grid-template-rows: minmax(0, 1fr);
    width: 100%;
    position: relative;
    overflow-y: hidden;
    ${(props) => props.theme.pearlBreaks.up(BreakpointSizes.MD)} {
        height: ${({ $topOffset, $compactScroll }) =>
            $compactScroll
                ? compactLayoutHeight($topOffset)
                : $topOffset > 0
                ? `calc(95vh - ${$topOffset}px)`
                : '95vh'};
    }
    ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.SM)} {
        height: ${({ $topOffset, $compactScroll }) =>
            $compactScroll ? compactLayoutHeight($topOffset) : '1120px'};
    }

    .rightSide {
        height: 100%;
        min-height: 0;
    }

    .innerRight {
        flex: 2 1;
        display: flex;
        flex-direction: column;
        height: ${({ $noFooterSpace }) => ($noFooterSpace ? '100%' : 'calc(100% - 78px)')};
        position: relative;
        overflow-y: auto;
        background-color: ${(props) => props.theme.colors.background.container};
    }

    footer {
        height: 78px;
        width: 100%;
    }

    .title {
        text-transform: none;
        margin-top: 10px;
        margin-bottom: 0px;
        font-weight: 700;
        font-size: 40px;
        line-height: 48px;

        @media (max-width: 815px) {
            font-size: 32px;
        }
    }

    .stepHeader,
    .stepComponent {
        padding-left: 48px;
        padding-right: 48px;
        width: auto;

        ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.LG)} {
            padding-left: 48px;
            padding-right: 48px;
        }

        ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.MD)} {
            padding-left: 32px;
            padding-right: 32px;
            padding-top: 20px;
        }
        ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.SM)} {
            padding: 0px 16px;
        }
    }

    .stepHeader {
        display: flex;
        flex-direction: column;
        flex: 1 1 auto;

        &.welcomeTrialHeader {
            padding-top: 0;

            & > :first-child:not(.actions):not(.mobileTopBar) {
                padding-top: 0;
            }
        }

        & > :first-child.actions {
            ${(props) => props.theme.pearlBreaks.up(BreakpointSizes.MD)} {
                padding-top: 96px;
            }
        }

        & > :first-child:not(.actions):not(.mobileTopBar) {
            padding-top: 100px;
        }

        .eventUserTitles {
            margin: 20px 0 0;
        }
    }

    .stepComponent {
        min-height: 100px;
        flex: 1 1 100%;
        display: flex;
        flex-direction: column;
        justify-content: start;
        padding-top: 0;
        ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.MD)} {
            padding-bottom: 20px;
            min-height: auto;
        }

        .formWrapper {
            padding-bottom: 40px;
            margin-bottom: 100px;

            ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.MD)} {
                padding-bottom: 0;
                margin-bottom: 0;
            }
        }
    }

    .formComponent {
        ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.MD)} {
            margin: 0px 0px 0px 0px;
        }
    }

    .image {
        display: flex;
        position: relative;
        width: 100%;
        height: 100vh;
        img {
            object-fit: cover;
            height: 100%;
            width: 100%;
        }

        .logo {
            height: auto;
            width: 25%;
        }
    }

    .subtitle {
        color: ${(props) => props.theme.colors.foreground.secondary_text};
        margin-bottom: 0px;
        margin-top: 10px;
    }

    .subtitle.pearl-connect-subtitle-accent {
        color: ${(props) => props.theme.colors.foreground.base};
    }

    ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.MD)} {
        display: grid;
        grid-template-rows: 32% auto;
        grid-template-columns: unset;
        height: 100%;
        overflow-y: auto;
        width: 100vw;

        footer {
            position: fixed;
            bottom: 0;
            left: 0;
            width: 100%;
        }

        .image {
            height: 100%;
            flex: 1 0 auto;
            width: 100vw;
            max-width: unset;
        }

        .rightSide {
            height: 100%;
            width: 100vw;
        }

        .innerRight {
            height: calc(100% - 79px);
            overflow: visible;
        }

        .stepHeader {
            padding-top: 96px;
        }

        .welcomeTrialHeader {
            padding-top: 0 !important;
        }
    }
    ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.SM)} {
        .stepHeader {
            padding-top: 12px;
            padding-left: 16px;
            padding-right: 16px;
        }

        .welcomeTrialHeader {
            padding-top: 0 !important;
        }
    }

    ${({ $compactScroll, $compactWelcomeHeader }) =>
        $compactScroll &&
        css`
            flex: 1 1 auto;
            min-height: 0;
            overflow-y: hidden;

            .rightSide {
                height: 100%;
                display: flex;
                flex-direction: column;
                min-height: 0;

                @media (max-width: 815px) {
                    overflow: hidden;
                }
            }

            .innerRight {
                flex: 1 1 auto;
                min-height: 0;
                height: auto;
                overflow-y: auto !important;
                -webkit-overflow-scrolling: touch;
                scroll-padding-bottom: 16px;

                ${$compactWelcomeHeader &&
                css`
                    scroll-padding-bottom: 108px;

                    @media (max-width: 815px) {
                        scroll-padding-bottom: 16px;
                    }
                `}

                @media (max-width: 815px) {
                    overflow-y: auto !important;
                }
            }

            .stepHeader {
                flex: 0 0 auto;
                padding-top: 0;
            }

            .welcomeTrialHeader {
                padding-top: 0 !important;
                padding-bottom: 0;
            }

            .stepComponent {
                flex: 0 0 auto;
                overflow: visible;
                min-height: 0;
                padding-bottom: 0;
            }

            .formWrapper {
                margin-bottom: 0;
                padding-bottom: 16px;

                ${$compactWelcomeHeader &&
                css`
                    padding-bottom: 108px;

                    @media (max-width: 815px) {
                        padding-bottom: 0;
                    }
                `}
            }

            footer {
                height: auto;
                min-height: auto;
                padding: 0;
                border: none;
                overflow: visible;
            }

            .welcomeTrialFooter {
                flex-shrink: 0;
                width: 100%;
            }
        `}

    ${({ $compactScroll, $topOffset }) =>
        $compactScroll &&
        css`
            ${(props) => props.theme.pearlBreaks.down(BreakpointSizes.MD)} {
                display: flex;
                flex-direction: column;
                grid-template-rows: unset;
                grid-template-columns: unset;
                overflow-y: hidden;
                width: 100%;
                height: ${compactLayoutHeight($topOffset)};

                .rightSide {
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    flex: 1 1 auto;
                    min-height: 0;

                    @media (max-width: 815px) {
                        overflow: hidden;
                    }
                }

                .innerRight {
                    height: auto;
                    flex: 1 1 auto;
                    min-height: 0;
                    overflow-y: auto !important;
                    -webkit-overflow-scrolling: touch;
                }

                .welcomeTrialHeader {
                    padding-top: 0 !important;
                }

                .stepHeader {
                    padding-top: 0;
                }

                .stepComponent {
                    padding-bottom: 0;
                }

                footer {
                    height: auto;
                    min-height: auto;
                    overflow: visible;
                }

                .welcomeTrialFooter {
                    flex-shrink: 0;
                    width: 100%;
                }
            }
        `}

    /* Opt-in (compactHeader): tighter header and no bottom gutter on desktop so a whole step can
       fit on one screen. Off for every other step. */
    ${({ $compactHeader }) =>
        $compactHeader &&
        css`
            ${(props) => props.theme.pearlBreaks.up(BreakpointSizes.MD)} {
                .mobileTopBar {
                    min-height: 48px !important;
                    padding-top: 8px !important;
                    padding-bottom: 8px !important;
                    margin-bottom: 4px !important;
                }

                .title {
                    margin-top: 4px;
                    font-size: 32px;
                    line-height: 40px;
                }

                .subtitle {
                    margin-top: 4px;
                }

                .formWrapper {
                    margin-bottom: 0;
                    padding-bottom: 16px;
                }
            }
        `}
`;
